export const WIZARD_TYPES: { [key: string]: string } = {
  choiceHelper: 'keuzehulp',
  default: 'default-wizard',
  resultTags: 'result-tags-wizard',
};

export const WIZARD_COMPONENT = {
  wizardCheckbox: 'wizard-checkbox',
  wizardFaqItem: 'wizard-faq-item',
};

export const WIZARD_RESULT = {
  maxProducts: 3,
  maxArticles: 3,
};

export const WIZARD_SLUG = {
  conversation: 'breedtegesprek',
  intake: 'productwijzer',
};

export const WIZARD_NAME = {
  conversationWizard: 'Breedtegesprek',
  cyberWizard: 'Cyberrisicoscan',
  intakeWizard: 'Productwijzer',
  choiceHelpWizard: 'Routekaart voor verduurzaming',
  youlend: 'YouLend',
};

export const WIZARD_ID = {
  oldCyberWizard: '28c2f117-a07b-5d5d-86c1-95b83aea74df',
  oldIntakeWizard: '209433af-ded0-5a90-906f-8d9b8d9ed251',
};

export const WIZARD_CARDS_ELEVATION: { [key: string]: 'low' | 'high' } = {
  low: 'low',
  high: 'high',
};
